<template>
  <ShowControl  @revert="revertClick"  :title="title" ref="showControl">
  <div style="display: flex; flex-flow: column; height: 100%; width: 100%"  v-if="showMain">
    <div class="main">
      <div class="fourdiv">
        <div class="marketingbox">
            <FrameControl>
              <div class="flexbox">
                <el-card class="marketingitem" @click="Details(o)"
                     v-for="(o, i) in AllPlatform"
                     :key="i">
                  <el-tooltip :content="o.name"
                              placement="bottom"
                              effect="light">
                    <img :src="Global.imgip + o.icon"
                         class="hand"
                          />
                  </el-tooltip>
                </el-card>
              </div>
            </FrameControl>                  
          </div>
        <div>
          <div class="Chartbox">
            <FrameControl>
              <MarketingCostStatistics  v-if="StatisticsShow"></MarketingCostStatistics>
              <div class="flexbox" v-if="ReceiptShow"
                   style="width: 90%">
                <el-alert v-for="(i, index) in AllReceipt"
                          :key="index"
                          :title="i.name+'&nbsp;&nbsp;&nbsp;&nbsp;'+Global.ReceiptType.filter(c=>c.id==i.buissType)[0].name"
                          :description="i.describe"
                          type="info"
                          effect="dark"
                          @close="READ(i)" style="background-color: #42b8dd;" ></el-alert>
              </div>
            </FrameControl>
          </div>
        </div>
        <div>
          <div class="marketingbox">
            <FrameControl>
              <div class="flexbox">
                <div class="icondiv">
                  <div>
                    <el-button type="text"
                               @click="MediainvitaClick">
                      <div>
                        <div>
                          <i class="icon iconfont icon-yaoyue"
                             style="font-size:calc(100vw * 80 / 1920)"></i>
                        </div>
                        <div >媒体邀约</div>
                      </div>
                    </el-button>
                  </div>
                  <div>
                    <el-button type="text"
                               @click="AttractInvestmentClick">
                      <div>
                        <div>
                          <i class="icon iconfont icon-zhaoshanghezuo"
                             style="font-size:calc(100vw * 80 / 1920)"></i>
                        </div>
                        <div >主题演讲招商</div>
                      </div>
                    </el-button>
                  </div>

                  <div>
                    <el-button type="text"
                               @click="BoothAttractInvestmentClick">
                      <div>
                        <div>
                          <i class="icon iconfont icon-jiancaizhaoshangxiaochengxu-menchuang"
                             style="font-size:calc(100vw * 80 / 1920)"></i>
                        </div>
                        <div >展位招商</div>
                      </div>
                    </el-button>
                  </div>
                  <div>
                    <el-button type="text"
                               @click="AdvertAttractInvestmentClick">
                      <div>
                        <div>
                          <i class="icon iconfont icon-guanggao"
                             style="font-size:calc(100vw * 80 / 1920)"></i>
                        </div>
                        <div >广告招商</div>
                      </div>
                    </el-button>
                  </div>
                  <div>
                    <el-button type="text"
                               @click="NewsCoverageClick">
                      <div>
                        <div>
                          <i class="icon iconfont icon-xinwen"
                             style="font-size:calc(100vw * 80 / 1920)"></i>
                        </div>
                        <div >展后新闻报道</div>
                      </div>
                    </el-button>
                  </div>
                  <div>
                    <el-button type="text"
                               @click="TrackAndMarketingClick">
                      <div>
                        <div>
                          <i class="icon iconfont icon-fapiao"
                             style="font-size:calc(100vw * 80 / 1920)"></i>
                        </div>
                        <div >现场跟踪及营销</div>
                      </div>
                    </el-button>
                  </div>
                  <div>
                    <el-button type="text"
                               @click="MarketingSummarizeClick">
                      <div>
                        <div>
                          <i class="icon iconfont icon-niandugongzuogaishu"
                             style="font-size:calc(100vw * 80 / 1920)"></i>
                        </div>
                        <div >会展营销总结</div>
                      </div>
                    </el-button>
                  </div>
                </div>
              </div>
          </FrameControl>
          </div>
        </div>
        <div>
          <div class="Chartbox">
            <FrameControl>
              <div class="flexbox"
                   style="width: 90%">
                <el-card style="width: 100%;margin-bottom: 10px;background-color"
                         v-for="(item, index) in AllAttractInvestment"
                         :key="index">
                  <h4>{{ item.name }}</h4>
                  <P class="text">{{
                      item.type +
                      '&nbsp;&nbsp;&nbsp;&nbsp;'
                    }}<span v-if="item.personnelType!=null">招商类型：{{item.personnelType}} </span></P>
                </el-card>

              </div>
            </FrameControl>
          </div>
        </div>
      </div>
    </div>
  </div>
</ShowControl>

</template>

<script>
import { mapState } from 'vuex'
import MarketingCostStatistics from "../MiceMarketing/MarketingCostStatistics.vue";
import ShowControl from "../UserControl/ShowControl.vue"
import FrameControl from "../UserControl/FrameControl.vue"
export default {
  components: {
    MarketingCostStatistics,
    ShowControl,
    FrameControl,
  },
  data () {
    return {
      Platform: {},
      NewsCoverageEditCardView:false,
      marktingList: [{}],
      caseID: localStorage.getItem('caseId'),
      flowID: localStorage.getItem("flowID"),
      AllMediaCompanysList: [],
      AllPlatform: [],
      AllAttractInvestment: [],
      AllReceipt: [],
      title: '会展营销',
      showMain: true,
      mediaChild: false,
      IsMediaDeatil: false,
      mediaform : {},
      IsThemeEnterprise: false,
      IsThemeExpert:false,
      newsCoverageform:{},
      StatisticsShow:false,
      ReceiptShow:false

    }
  },
  created () {
  },
  beforeRouteUpdate(to,from,next)
  {
    next(vm=>
    {
      console.log(vm);
    })
    if (to.query.str != undefined) {
      this.cardview(to.query.str);
    }
  },
  mounted () {
    if (this.$route.query.str != undefined) {
      this.cardview(this.$route.query.str);
    }
    this.GetallplatformMD()
    this.GetAllAttractInvestment()
    this.GetReceipt()
    if(this.flowID <= 2){
      this.StatisticsShow = true
    }else{
      this.ReceiptShow = true
    }
  },
  provide () {
    return {
      GetAllAttractInvestment: this.GetAllAttractInvestment,
    }
  },
  computed: {
    ...mapState({
      round: (state) => state.user.round,
    }),
  },
  watch: {},
  methods: {
    cardview(str)
    {
      this.$refs.showControl.receiveValue(true);
      this.showMain=false
      this.handleClose()
      if(str=='InformationCard')
      {
        this.$http.get('Platform/GetModel').then((res) => {
          if (res.success) {
            this.AllPlatform = res.dynamicObj
            this.Platform = this.AllPlatform[0]
            this.$router.push({path:'InformationCard',query:{ id : this.Platform.id }})
          } else {
            this.$message.warning(res.message)
          }
        })
      }else if(str=='MediaInvitationsCard')
      {
        this.$router.push("/MediaInvitationsCard")
      }else if(str=='ExpertCard' ||str=='CompanyCard')
      {
        this.$router.push("/ThemeAttractInvestmentCard")
      }else if(str=='BoothAttractInvestmentCard')
      {
        this.$router.push("/BoothAttractInvestmentCard")
      }else if(str=='AdvertAttractInvestmentCard')
      {
        this.$router.push("/AdvertAttractInvestmentCard")
      }else if(str=='TrackAndMarketingCard')
      {
        this.$router.push("/TrackAndMarketingCard")
      }
      else if(str=='NewsCoverageCard')
      {
        this.$router.push("/NewsCoverageCard")
      }
    },
    handleClose() {
      this.IsMarketingSummarize = false
      this.IsTrackAndMarketing = false
      this.IsNewsCoverage = false
      this.IsAdvertAttractInvestment = false
      this.IsBoothAttractInvestment = false
      this.IsAttractInvestment = false
      this.IsMediaInvit = false
      this.IsInformation = false
      this.IsThemeEnterprise=false
      this.IsThemeExpert = false
      this.NewsCoverageEditCardView= false
      this.IsMediaDeatil = false
    },
    MarketingSummarizeClick () {
      if (this.flowID != this.Global.FlowList.实验总结) {
        this.$message.error("当前流程阶段不是实验总结，无法进行操作！");
        return;
      }
      this.$router.push("/MarketingSummarizeCard")
    },
    TrackAndMarketingClick () {
      this.$router.push("/TrackAndMarketingCard")
    },
    NewsCoverageClick () {
      this.$router.push("/NewsCoverageCard")
    },
    AdvertAttractInvestmentClick () {
      this.$router.push("/AdvertAttractInvestmentCard")
    },
    BoothAttractInvestmentClick () {
      this.$router.push("/BoothAttractInvestmentCard")
    },
    AttractInvestmentClick () {
      this.$router.push("/ThemeAttractInvestmentCard")
    },
    MediainvitaClick () {
      this.$router.push("/MediaInvitationsCard")
    },
    GetallplatformMD () {
      this.$http.get('Platform/GetModel').then((res) => {
        if (res.success) {
          this.AllPlatform = res.dynamicObj
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    GetAllAttractInvestment () {
      this.$http
        .get(`AttractInvestment/GetAllAttractInvestment?round=${this.round}`)
        .then((res) => {
          if (res.success) {
            this.AllAttractInvestment = res.dynamicObj
          } else {
            this.$message.warning(res.message)
          }
        })
    },
    Details (platform) {
      this.$router.push({path:'InformationCard',query:{ id : platform.id }})
    },
    //回执接口
    GetReceipt () {
      this.$http.get(`Receipt/GetReceipt?round=${this.round}`).then((res) => {
        if (res.success) {
          this.AllReceipt = res.dynamicObj.filter(
            (t) => t.state != this.Global.ReceiptState.READ
          )
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    //回执按钮
    READ (row) {
      let list = [
        {
          uuid: row.uuid == null ? this.uuid.guid() : row.uuid,
          state: this.Global.SModel.Delete,
          sTTime: this.filter.formatDate(new Date()),
          groupId: this.Global.groupid,
          ReceiptId: row.id,
          round: this.round,
          type: 'S_Receipt',
          buissType:row.buissType
        },
      ]
      this.$http
        .post('SModel/PushStrategy', this.Global.getsmodel(list))
        .then((res) => {
          if (res.success) {
            this.Global.GetBudget(row.cost)
            // this.Global.sendmsgmd('会展营销', `已读${row.name}的回执信息`, 1)
            this.$message.success(`已读${row.name}的回执信息`)
            this.GetReceipt()
          } else {
            return this.$message.error(res.message)
          }
        })
    },
    revertClick(){
      if(this.IsMediaDeatil)
      {
        this.IsMediaDeatil = false
        this.MediainvitaClick();
      } 
      else if(this.IsThemeExpert){
        this.IsThemeExpert = false
        this.AttractInvestmentClick()
      }
      else if(this.IsThemeEnterprise){
        this.IsThemeEnterprise = false
        this.AttractInvestmentClick()
      }
      else if(this.NewsCoverageEditCardView){
        this.NewsCoverageEditCardView = false
        this.NewsCoverageClick()
      }
      else{
        this.showMain=true
        this.title = '会展营销'
        this.handleClose();
      }
    },
    Mediaform(data){
      this.IsMediaInvit = false
      this.mediaform =  data
      this.IsMediaDeatil = true
    },
    expertShow(data){
      this.title = '主题演讲专家'
      this.IsAttractInvestment = false
      this.IsThemeExpert = data
    },
    EnterpriseShow(data){
      this.title = '主题演讲企业'
      this.IsAttractInvestment = false
      this.IsThemeEnterprise = data
    },
    NewsCoverageform(data){
      this.IsNewsCoverage=false
      this.newsCoverageform= data
      this.NewsCoverageEditCardView = true
    }
  },
}
</script>
<style>
.el-card__body {
    padding: calc(100vw * 20 / 1920);
}
</style>
<style lang="less" scoped>
.fourdiv {
  display: flex;
  /* flex: auto; */
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-wrap: wrap;
  height: 100%;
  border-radius: 0px 0px 15px 15px;
  > div {
    display: flex;
  flex-wrap: wrap;
  margin: 10px;
  height: calc((100% - 40px) / 2);
  width: calc((100% - 60px) / 2);
  }
}
.icondiv {
  display: flex;
  flex-flow: wrap;
  justify-content: center;
  height: 100%;
  width: 100%;
  align-content: center;
  align-items: center;
  overflow: auto;
  > div {
    display: flex;
    width: 23%;
    text-align: center;
    height: 45%;
    justify-content: center;
  }
}
</style>
<style scoped>
.el-alert {
  margin: 20px 0 0;
}
.el-alert:first-child {
  margin: 0;
}
.main {
  height: 100%;
  /* background-color: #e8e8e8; */
  border-radius: 0px 0px 15px 15px;
}
.box {
  margin: 0 10px;
  height: 100%;
}
.marketingbox {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.el-row {
  height: 99%;
}
.Chartbox {
  height: 100%;
  width: 100%;
}
.Chartbox:last-child {
  position: relative;
}
.marketingitem {
  display: flex;
  align-items: center;
  width: 18%;
  height: 28%;
  border-radius: 10%;
  overflow: hidden;
  margin: calc(100vw * 5 / 1920) calc(100vw * 10 / 1920);
  background-color: rgb(255, 255, 255);
  transform: scale(1);
  transition: all 0.6s;
}
.marketingitem1 {
  width: 18%;
  height: 30%;
  border-radius: 10%;
  overflow: hidden;
  margin: 5px 5px;
  background-color: rgb(255, 255, 255);
}
.marketingitem:hover {
  transform: scale(1.2);
}
.flexbox {
  overflow: auto;
  width: 90%;
  height: 90%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  position: relative;
  top: 5%;
  left: 5%;
}
.flexbox1 {
  overflow: auto;
  width: 99%;
  height: 50%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  position: relative;
  top: 25%;
  left: 30%;
}
.hand {
  cursor: pointer;
  width: 100%;
  height: 100%;
}
.iconfont {
  font-size: 2.5vw;
}
.box-11 {
  height: 100%;
}
.span {
  font-size: 20px;
  color: white;
}
.span1 {
  font-size: 20px;
  color: orange;
  font-weight: bold;
}
.text {
  font-size: 14px;
}
</style>
